import { BaseMapper } from '@/core/mapper';

import { Country } from '@/core/common';

const schema = {
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  name: {
    label: 'Location name',
    parseFrom: 'attributes.name',
  },
  address: {
    label: 'Address',
    parseFrom: 'attributes.address',
  },
  suburb: {
    label: 'Suburb',
    parseFrom: 'attributes.suburb',
  },
  state: {
    label: 'State',
    parseFrom: 'relationships.state.attributes',
    toRequest: entity => ({
      state_uuid: _.get(entity, 'state.uuid'),
    }),
  },
  client: {
    parseFrom: 'relationships.client.attributes',
    omitFromRequest: true,
  },
  site_access: {
    parseFrom: 'attributes.site_access',
    label: 'Check-in required',
  },
  checkin_url: {
    parseFrom: 'meta.checkin_url',
  },
  checked_in_workers_count: {
    label: 'Workers on site',
    parseFrom: 'meta.checked_in_workers_count',
  },
  webname: {
    parseFrom: 'attributes.webname',
  },
  country: {
    fromResponse: (entity) => {
      const country = _.get(entity, 'relationships.country');
      return country && new Country(country);
    },
    toRequest: entity => ({
      country_uuid: _.get(entity, 'country.uuid'),
    }),
  },
  timezone: {
    parseFrom: 'attributes.timezone',
    label: 'Timezone',
  },
};

class Location extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

Location.schema = schema;

export default Location;
